import { defaultLinks } from "../config/defaults";
import { isLocalStorageEmpty, handleRestoreFromLocalStorage } from "./localStorageHandling";
import { setLanguage } from "../assets/creator/translations";
import templates from "../templates/templates";

function checkIsRefresh() {
    if (localStorage.getItem('isRefresh') === 'true') {
        localStorage.removeItem('isRefresh');
        this.setState({ isRefresh: true });
        return true;
    } else {
        this.setState({ isRefresh: false });
        return false;
    }
}

const checkLanguageFromAddress = () => {
    const linkOptions = window.location.search.substring(1).split('&');
    for (const option of linkOptions) {
      const pair = option.split('=');
        if (pair[0] === 'lang' && ['pl', 'en', 'de', 'fr'].includes(pair[1])) {
            setLanguage(pair[1]);
            return pair[1];
        }
    }
    return false;
}

function setMainOptions(checkingCondition, mainOptions, isWelcomeModalOpen, isTemplateMenuModalOpen, isInformativeModalVisible) {
    if (checkingCondition) {
        return {
            ...mainOptions,
            isWelcomeModalOpen: isWelcomeModalOpen,
            isTemplateMenuModalOpen: isTemplateMenuModalOpen,
            isInformativeModalVisible: isInformativeModalVisible
        }
    }
    return mainOptions;
}

function checkRestoreForSetState(isRestored) {
    if (isRestored) {
        handleRestoreFromLocalStorage.call(this);
    }
}

function checkAddressOptions() {
    const options = {};
    let mainOptions = {};
    const linkOptions = window.location.search.substring(1).split('&');
    let isRestored = false;
    let isNew = false;
    let selectedTemplateId = null;
    let selectedTemplate = null;
    for (const option of linkOptions) {
      const pair = option.split('=');
      options[pair[0]] = pair[1];
      switch (pair[0]) {
        case "model":
            if (pair[1] !== 'b2b') {
                break;
            }
            if (isLocalStorageEmpty.call(this)) {
                mainOptions = setMainOptions(true, mainOptions, false, true, false);
                break;
            }
            mainOptions = setMainOptions(true, mainOptions, true, false, true);
            break;
        case "edited":
          if (!isLocalStorageEmpty.call(this) && pair[1] === 'true') {
            isRestored = true;
            break;
          }
          if (pair[1] === 'false') {
            isNew = true;
          }
          break;
        case "template":
            selectedTemplateId = Number(pair[1]);
            if (isNaN(selectedTemplateId)) {
                break;
            }
            selectedTemplate = templates.find(template => template.id === selectedTemplateId);
            if (selectedTemplate && selectedTemplate.settings) {
                this.handleLoadProjectTemplatesMenu(selectedTemplate.settings, selectedTemplate.settings.theme);
                break;
            }
            if (selectedTemplateId === 0) {
                this.handleLoadNewProjectTemplatesMenu();
            }
            break;
        default:
          break;
      }
    }
    mainOptions = setMainOptions(isRestored, mainOptions, false, false, false);
    mainOptions = setMainOptions(isNew, mainOptions, false, true, false);
    this.setState({ ...mainOptions, addressOptions: options}, checkRestoreForSetState.call(this, isRestored));
    window.history.replaceState({}, '', '/');
}

const linksGenerator = async () => {
    try {
        const response = await fetch('./js/links.json').then(res => res.json());
        return response;
    } catch (error) {
        console.log("JSON file not found");
        return defaultLinks;
    }
}

export { checkIsRefresh, checkLanguageFromAddress, checkAddressOptions, linksGenerator };